import I18n from "../../../../../../../localization/I18n";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";
import { GridSideModalTitle } from "../../../../utils/GridModalUtils";
import { ImpactProcessSidebarModel } from "./ImpactProcessSidebar_model";
import { ImpactProcessSidebar } from "./ImpactProcessSidebar_view";

export const IMPACT_PROCESS_SIDEBAR_MODAL_CONFIG = (
  organisationId: number,
  projectId: number,
  impact: FP.Entities.IImpact
) => {
  return {
    showClose: true,
    title: <GridSideModalTitle name={impact.name} field={I18n.t("phrases.processes")} />,
    content: (
      <ImpactProcessSidebar
        model={new ImpactProcessSidebarModel(ModalContext.hide, organisationId, projectId, impact.id)}
      />
    )
  };
};
